import React from 'react';
import loadable from '@loadable/component';
import Base64Deriver from 'derivers/Base64';
import { PlanProduct, TrialProduct } from 'features/Products/products';
import { activateProductOnEnter } from 'features/Products/Products.helpers';
import { purchaseOnEnterSaga } from './Purchase.onenter.saga';

const PurchaseContainer = loadable(() => import('./PurchaseContainer'));
const IdealLandingContainer = loadable(() => import('./components/IdealLandingContainer'));

export const PurchaseRoute = (store, client) => ({
  path: 'purchase',

  onEnter: (nextState, replaceState, cb) =>
    store
      .runSagaOnce(purchaseOnEnterSaga, client, nextState, replaceState)
      .toPromise()
      .then(cb, cb),

  childRoutes: [
    {
      path: 'offer/:encodedMsaOfferId',
      component: props => <PurchaseContainer {...props} />,
      onEnter: (...args) => {
        activateProductOnEnter(store, TrialProduct, params => ({
          msaOfferId: Base64Deriver.decodeNumber(params.encodedMsaOfferId),
        }))(...args);
      },
    },
    {
      path: 'plan/:encodedPlanId',
      component: props => <PurchaseContainer {...props} />,
      onEnter: activateProductOnEnter(store, PlanProduct, params => ({
        planId: Base64Deriver.decodeNumber(params.encodedPlanId),
      })),
    },
    {
      path: 'pending',
      component: props => <IdealLandingContainer {...props} />,
    },
  ],
});
